import { Download, Search, CheckCircle2, XCircle } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { leads, campaigns } from '@/lib/mockData';

const campaignName = (id: string) => campaigns.find(c => c.id === id)?.name ?? '—';

const PartenaireLeads = () => (
  <DashboardLayout
    role="partenaire"
    user={{ name: 'Marie Koné', subtitle: 'Orange CI', initials: 'MK' }}
  >
    <PageHeader
      title="Leads qualifiés"
      subtitle="Base opt-in collectée à travers tes campagnes — prête à exporter."
      actions={
        <Button size="sm" className="shadow-cta">
          <Download className="size-4" />
          Exporter en CSV
        </Button>
      }
    />

    <div className="mb-4 flex flex-wrap items-center gap-3">
      <div className="relative w-full max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Rechercher un lead…" className="h-10 pl-9" />
      </div>
      <p className="text-xs text-muted-foreground">{leads.length} leads collectés</p>
    </div>

    <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-muted/50">
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-5 py-3">Nom</th>
            <th className="px-5 py-3">Email</th>
            <th className="px-5 py-3">Téléphone</th>
            <th className="px-5 py-3">Campagne</th>
            <th className="px-5 py-3">Ville</th>
            <th className="px-5 py-3">Date</th>
            <th className="px-5 py-3 text-right">Opt-in</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {leads.map(l => (
            <tr key={l.id} className="hover:bg-muted/30">
              <td className="px-5 py-3 font-medium">{l.name}</td>
              <td className="px-5 py-3 text-muted-foreground">{l.email}</td>
              <td className="px-5 py-3 text-muted-foreground">{l.phone}</td>
              <td className="px-5 py-3 text-muted-foreground">{campaignName(l.campaignId)}</td>
              <td className="px-5 py-3 text-muted-foreground">{l.city}</td>
              <td className="px-5 py-3 text-muted-foreground">{l.date}</td>
              <td className="px-5 py-3 text-right">
                {l.optIn ? (
                  <span className="inline-flex items-center gap-1 text-emerald-600">
                    <CheckCircle2 className="size-4" />
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-muted-foreground">
                    <XCircle className="size-4" />
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DashboardLayout>
);

export default PartenaireLeads;
